import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M9.91675 8.75065C10.2389 8.75065 10.5001 8.48948 10.5001 8.16732C10.5001 7.84515 10.2389 7.58398 9.91675 7.58398C9.59458 7.58398 9.33342 7.84515 9.33342 8.16732C9.33342 8.48948 9.59458 8.75065 9.91675 8.75065Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.16675 4.08398C1.16675 3.11749 1.95025 2.33398 2.91675 2.33398H9.33342C10.2999 2.33398 11.0834 3.11749 11.0834 4.08398V4.66732C12.0499 4.66732 12.8334 5.45082 12.8334 6.41732V10.5007C12.8334 11.4672 12.0499 12.2507 11.0834 12.2507H2.91675C1.95025 12.2507 1.16675 11.4672 1.16675 10.5007V4.08398ZM9.91675 4.08398V4.66732H2.33341V4.08398C2.33341 3.76182 2.59458 3.50065 2.91675 3.50065H9.33342C9.65558 3.50065 9.91675 3.76182 9.91675 4.08398ZM2.33341 10.5007V5.83398H11.0834C11.4056 5.83398 11.6667 6.09515 11.6667 6.41732V10.5007C11.6667 10.8228 11.4056 11.084 11.0834 11.084H2.91675C2.59458 11.084 2.33341 10.8228 2.33341 10.5007Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}